export const LabelText = ({ label, text }: { label: string; text: string }) => {
  return (
    <div>
      <p className="text-xs font-semibold text-gray-500 mb-1">{label}</p>
      <p className="text-md font-semibold">{text}</p>
    </div>
  );
};

export default {};
